import { FC } from 'react'
import Row from '../Row'
import { CircleProgress } from 'components/indicators/circle-progress'
import { TotalRow } from '../TotalRow'
import classNames from 'classnames'
import { totalWorkedInSeconds } from '@utils/timeCards'
import { useTranslation } from 'react-i18next'
import { AutoTextSize } from 'auto-text-size'
import { TimeCardsContextTimeCard } from '@features/time-logging/providers/TimeCardsContextProvider'

interface Props {
  timeCard: TimeCardsContextTimeCard
}

export const UnsubmittedBody: FC<Props> = ({ timeCard }) => {
  const { t } = useTranslation()
  const startTimeMissing = timeCard.startAt == null
  const endTimeMissing = timeCard.endAt == null
  const startOrEndTimeMissing = startTimeMissing || endTimeMissing

  // Consider a full day to either be the worker's scheduled work day,
  // or 8 hours for days the worker is not scheduled to work
  const fullDayInSeconds =
    (timeCard.scheduledWorkHours
      ? parseFloat(timeCard.scheduledWorkHours)
      : 8) *
    60 ** 2

  // Assume the user will work a full day as defined above,
  // unless they've configured a start/end time
  const totalWorkedOrAnticipatedToWorkInSeconds = startOrEndTimeMissing
    ? fullDayInSeconds
    : totalWorkedInSeconds(timeCard)

  return (
    <div>
      {startOrEndTimeMissing ? (
        <Row subtle={timeCard.isInFuture} className="border-b border-dashed">
          <AutoTextSize
            mode="oneline"
            maxFontSizePx={14}
            className="text-neutral-500 mx-auto"
          >
            {startTimeMissing
              ? t('features.timeLogging.enterStartTime')
              : t('features.timeLogging.enterEndTime')}
          </AutoTextSize>
        </Row>
      ) : (
        <TotalRow
          subtle={timeCard.isInFuture}
          totalInSeconds={totalWorkedInSeconds(timeCard)}
          className={classNames('border-b border-dashed', {
            'border-success-300': timeCard.isValid,
          })}
        />
      )}
      <TotalRow
        subtle={timeCard.isInFuture}
        totalInSeconds={timeCard.totalAllocatedInSeconds}
      >
        {
          <CircleProgress
            percentGreen={
              (timeCard.totalAllocatedInSeconds /
                totalWorkedOrAnticipatedToWorkInSeconds) *
              100
            }
            percentRed={
              ((timeCard.totalAllocatedInSeconds -
                totalWorkedOrAnticipatedToWorkInSeconds) /
                totalWorkedOrAnticipatedToWorkInSeconds) *
              100
            }
            className="absolute w-5 h-5"
          />
        }
      </TotalRow>
    </div>
  )
}
